// FIXME: should not be a hook really.
// It should be a function with event handler so we can use it with %JS{}

const SmoothScrollToHook = {
  mounted() {
    this.el.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const target = document.querySelector(this.el.getAttribute('href'));
      target.scrollIntoView({
        behavior: 'smooth',
      });
    });
  },
};

export default SmoothScrollToHook;
